import { Recording } from 'features/recordings/recordingsSlice';
import { getState } from 'store';
import { cloudflareUrl } from 'utilities/cloudflareImageResizer';

export interface RecordingModel extends Recording {
  isPublic(): boolean;
  isUnlisted(): boolean;
  isOnlyVisibleToCreator(): boolean;
  recordingArtworkUrl(): string;
}

export const compareRecordingsById = (
  recording1: Recording,
  recording2: Recording
): number => {
  if (parseInt(recording1.id) < parseInt(recording2.id)) {
    return 1;
  } else {
    return -1;
  }
};

export const generateArtworkUrl = (key: string | null): any => {
  if (key != null) {
    return cloudflareUrl(key, {
      width: 800,
      quality: 80
    });
  } else {
    return '';
  }
};

export const RecordingModel = (recording: Recording): RecordingModel => {
  return {
    ...recording,
    isPublic() {
      return this.accessLevel == 'public';
    },
    isUnlisted() {
      return this.accessLevel == 'unlisted';
    },
    isOnlyVisibleToCreator() {
      const {
        currentUser: { me }
      } = getState();
      return this.accessLevel === 'only_me' && me?.id === this.userId;
    },
    recordingArtworkUrl() {
      return generateArtworkUrl(this.artworkKey);
    }
  };
};
